// 8:46pm 02022024

// let formData = {
//  'items': [{
//   'id': 36110175633573,
//   'quantity': 2
//   }]
// };

// fetch(window.Shopify.routes.root + 'cart/add.js', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify(formData)
// })
// .then(response => {
//   return response.json();
// })
// .catch((error) => {
//   console.error('Error:', error);
// });

// $(document).ready(function(){




function CallCardAddCardData(params) {
    fetch('/cart.js', {
            method: 'GET',
            dataType: "json",
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
        .then(data => {
            debugger;
            var _ggData;
          var _idProduct = 0;
            $.each(data.items, function(key, _item) {
              // _itemQ = data.items[0].quantity;
                _idProduct = data.items[0].product_id;
               // _idVariant = data.items[0].variant_id;
            });
           var _idVariant = params.id;
           var _itemQ = params.quantity;
            // alert('Cart Token ID:  ' + data.token);
            // alert('Quantity: ' + _itemQ);
            // alert('Product Id: ' + _idProduct);
            // alert('Variant Id: ' + _idVariant);
            debugger;

            var customerEmail = $('#customer_email').html();
            var customerId = $('#customer_Id').html();
          debugger;
            var ShopifyCheckouttoken = '';
          if(Shopify.Checkout != undefined || Shopify.Checkout != null)
          {
           ShopifyCheckouttoken = Shopify.Checkout.token;
          }
            addcarddata(customerId, _itemQ, _idVariant, _idProduct, data.token, ShopifyCheckouttoken, customerEmail);
        });
}

function addcarddata(customerId, _itemQ, _idVariant, _idProduct, datatoken, ShopifyCheckouttoken, customerEmail) {

    let payloadDataadd = {};

    payloadDataadd.customerid = customerId;
    payloadDataadd.qty = _itemQ;
    payloadDataadd.variantid = _idVariant;
    payloadDataadd.productid = _idProduct;
    payloadDataadd.carttoken = datatoken;
    payloadDataadd.sessionid = ShopifyCheckouttoken;
    payloadDataadd.emailid = customerEmail;
    $.ajax({
        headers: _apiheaders,
        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetail',
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(payloadDataadd),
        success: function(result) {
            debugger
          location.reload();
          // console.log(result.content[0].id);
          console.log(result);
          //alert(result.content[0].id);
          }
        //console.log(response);
    });
}


function getcarddata(customerEmail, prodcutid) {
  $.ajax({
        headers: _apiheaders,
        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetail/'+customerEmail,
        type: 'GET',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function(result) 
        {
          let payloadDataadd = {};
          let _items =[];
         $.each(result.content, function(key, _item) {
            let obj ={};
            obj.id = _item.variantid;
            obj.quantity = _item.qty;
            _items.push(obj);
           });
        payloadDataadd.items = _items;
        fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },body: JSON.stringify(payloadDataadd)
                })
                .then(response => {
                  //alert('Added');
                  console.log('Added');
                })
        }
    });
}

async function updateCardSessionToken(params) {
  debugger;
  let payloadDataadd = {};
    payloadDataadd.carttoken = params.carttoken;
    payloadDataadd.sessionid = params.sessionid;
    payloadDataadd.emailid = params.emailid;
    payloadDataadd.variantid = params.variantid;
    payloadDataadd.gstin = params.gstin;
  
    $.ajax({
        headers: _apiheaders,
        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetail',
        type: 'PUT',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(payloadDataadd),
        success: function(result) {
            debugger
          console.log(result);
         // alert(jQuery('#main-header').text().includes('Thank you'));
          if(jQuery('#main-header').text().includes('Thank you'))
          {
            let _payloadDataadd = {};
            _payloadDataadd.emailid = payloadDataadd.emailid;
            $.ajax({
                headers: _apiheaders,
                url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetailPaymentDelete',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(_payloadDataadd),
                success: function(result) {
                    console.log(result);
                  let _payloadSessionDelete = {};
                  _payloadSessionDelete.emailid = params.emailid;
                  _payloadSessionDelete.sessionid = params.sessionid;
                       $.ajax({
                        headers: _apiheaders,
                        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetailSessionDelete',
                        type: 'POST',
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        data: JSON.stringify(_payloadSessionDelete),
                        success: function(result) {
                            console.log(result);
                        }
                    });
                }
            });
          }
        }
        //console.log(response);
    });
}

function CardDelete(emailid,customerid,variantid) {
    debugger;
    let payloadDataadd = {};
  
    payloadDataadd.customerid = customerid;
    payloadDataadd.variantid = variantid;
    payloadDataadd.emailid = emailid;
    $.ajax({
        headers: _apiheaders,
        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetailDelete',
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(payloadDataadd),
        success: function(result) {
            debugger
           console.log(result);
          if(result!= null && result.content != null){
            //alert(result.content[0].id);
          }
        }
        //console.log(response);
    });
}

function CardDeleteAfterSuccessOrder(emailid,sessionid) {
    debugger;
    let payloadDataadd = {};
  
    payloadDataadd.sessionid = sessionid;
    //payloadDataadd.variantid = emailid;
    payloadDataadd.emailid = emailid;
    payloadDataadd.IsForCartDetailAfterSucessOrder = true;
    $.ajax({
        headers: _apiheaders,
        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetailDelete',
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(payloadDataadd),
        success: function(result) {
            debugger
          $.ajax({
        headers: _apiheaders,
        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetail/'+emailid,
        type: 'GET',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function(result) 
        {
          if(result != null && result.content != null)
          {
            if(result.content.length > 0)
            {
              let payloadDataadd = {};
              let _items =[];
                  $.each(result.content, function(key, _item) {
                    let obj ={};
                    obj.id = _item.variantid;
                    obj.quantity = _item.qty;
                    obj.carttoken = _item.carttoken;
                    _items.push(obj);
                  });
                payloadDataadd.items = _items;
                
                $.each(payloadDataadd.items, function(key, shopfy_item) 
                {
                    $.ajax({
                    url: 'https://rdonlineserviceqa.myshopify.com/cart/change.js?id='+shopfy_item.id+'%3A'+shopfy_item.carttoken+'&quantity=0',
                    type: 'GET',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function(result) 
                    {
                      console.log(result);
                      debugger;
                    }});
                });
            }
          }
        }
    });
        }
        //console.log(response);
    });
}


async function syncCardData(customerEmail) {
 
        var cartmodel= {};
        var shopifycartietmlist= [];
  
        var payloadDataadd = {};
        var _items =[];

        var cartToken;
  debugger;
  fetch('/cart.js', {
            method: 'GET',
            dataType: "json",
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
        .then(data => {
          debugger;
          if(data != null && data.items != null)
          {
           // if(data.items.length > 0 && data.items[0].product_id != '6895061336134')
           // {
           //   return false;
           // } 
            
          cartToken = data.token;
          $.each(data.items, function(key, _item) 
            {
              var _obj = {};
              _obj.id = _item.id;
              _obj.quantity = _item.quantity;
              _obj.key = _item.key;
              shopifycartietmlist.push(_obj);
            });
          
            $.ajax({
          headers: _apiheaders,
          url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetail/'+customerEmail,
          type: 'GET',
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          success: function(result) 
          {
          debugger;     
             $.each(result.content, function(key, _item) {
                    let obj ={};
                    obj.id = Number(_item.variantid);
                    obj.quantity = Number(_item.qty);
                    _items.push(obj);
              });
          payloadDataadd.items = _items;

            if(_items.length > shopifycartietmlist.length)
            {
                let additemincart =  _items.filter(o => !shopifycartietmlist.some(({id}) => o.id === id));
                let payloadforCart = {};
                let _itemsRow =[];
                 $.each(additemincart, function(key, rowItem) {
                    let obj ={};
                    obj.id = rowItem.id;
                    obj.quantity = rowItem.quantity;
                    _itemsRow.push(obj);
                   });
                payloadforCart.items = _itemsRow;
              $('#load').css("visibility", "visible");
              fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                      'Content-Type': 'application/json'
                      },body: JSON.stringify(payloadforCart)
                      })
                      .then(response => {
                        //alert('Added');
                        location.reload();
                        $('#load').css("visibility", "hidden");
                        console.log('Added');
                      })
            }else
            {
              if( _items.length == 0 && shopifycartietmlist.length > 0)
                {
                /* $.each(shopifycartietmlist, function(key, shopfy_item) 
                  {
                     $.ajax({
                      url: 'https://rdonlineserviceqa.myshopify.com/cart/change.js?id='+shopfy_item.id+'%3A'+cartToken+'&quantity=0',
                      type: 'GET',
                      contentType: "application/json; charset=utf-8",
                      dataType: "json",
                      success: function(result) 
                      {
                        debugger;
                      }});
                  }); */
                  
                    let _payloadDataadd = {};
                      _payloadDataadd.token = shopifycartietmlist.carttoken;
                          $.ajax({
                          url: 'https://rdonlineserviceqa.myshopify.com/cart/clear.js',
                          type: 'POST',
                          contentType: "application/json; charset=utf-8",
                          dataType: "json",
                          data: JSON.stringify(_payloadDataadd),
                          success: function(result) 
                          {
                            console.log('All Cart Detail Remove');
                            if( $('#continue_button').text() == "Pay now  ")
                            {
                              alert('Issue encountered! Please try to make an order again.');
                            }
                           
                            let payloadDataadd = {};
                            payloadDataadd.emailid = emailid;
                            $.ajax({
                                headers: _apiheaders,
                                url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetailPaymentDelete',
                                type: 'POST',
                                contentType: "application/json; charset=utf-8",
                                dataType: "json",
                                data: JSON.stringify(payloadDataadd),
                                success: function(result) {
                                    console.log(result);
                                      let _payloadSessionDelete = {};
                                    _payloadSessionDelete.emailid = customerEmail;
                                     $.ajax({
                                      headers: _apiheaders,
                                      url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetailSessionDelete',
                                      type: 'POST',
                                      contentType: "application/json; charset=utf-8",
                                      dataType: "json",
                                      data: JSON.stringify(_payloadSessionDelete),
                                      success: function(result) {
                                          console.log(result);
                                        var curURL = window.location.href;
                                      }
                                  });
                                }
                            });
                            console.log(result);
                          }});
                  
                }
              
                var _items_short = _items.sort(dynamicSort("id"));
                var shopifycartietmlist_short = shopifycartietmlist.sort(dynamicSort("id"));
                
                var variant_mismatch = shopifycartietmlist_short.filter((elem) => !_items_short.find(({ id }) => elem.id === id));
                var variant_quantity = _items_short.filter(o => shopifycartietmlist_short.some(({id,quantity}) => o.quantity !== quantity && o.id === id));
        
              if (variant_mismatch.length > 0 && variant_quantity.length > 0)
              {
                let _payload_Data = {};
                  $.each(variant_mismatch, function(key, shopfy_item) 
                  {
                    _payload_Data.id = shopfy_item.key;
                    _payload_Data.quantity = 0;
                  fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                        'Content-Type': 'application/json'
                        },body: JSON.stringify(_payload_Data)
                        })
                        .then(response => {
                          let _finalpayloadData = [];
                  let _payloadData = {};
                  $.each(shopifycartietmlist, function(key, shopfy_item) 
                  {
                   
                    if(variant_quantity.filter(o => o.id == shopfy_item.id).length > 0)
                     {
                       let _payloadData = {};
                       _payloadData.id = shopfy_item.key;
                        _payloadData.quantity = variant_quantity.filter(o => o.id == shopfy_item.id)[0].quantity;
                       _finalpayloadData.push(_payloadData);
                      }
                  });

                  if(variant_quantity.length == 1)
                  {
                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                        'Content-Type': 'application/json'
                        },body: JSON.stringify(_finalpayloadData[0])
                        })
                        .then(response => {
                          debugger;
                          location.reload();
                        })
                  }
                if(variant_quantity.length == 2)
                  {
                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                        'Content-Type': 'application/json'
                        },body: JSON.stringify(_finalpayloadData[0])
                        })
                        .then(response => {
                          debugger;
                                    fetch('/cart/change.js', {
                                  method: 'POST',
                                  headers: {
                                  'Content-Type': 'application/json'
                                  },body: JSON.stringify(_finalpayloadData[1])
                                  })
                                  .then(response => {
                                    debugger;
                                    location.reload();
                                  })
                        })
                   }
                        })
                    }
                  );
              }
              else
              {
                if(variant_mismatch.length > 0)
                {
                   let _payloadData = {};
                  $.each(variant_mismatch, function(key, shopfy_item) 
                  {
                    _payloadData.id = shopfy_item.key;
                    _payloadData.quantity = 0;
                  fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                        'Content-Type': 'application/json'
                        },body: JSON.stringify(_payloadData)
                        })
                        .then(response => {
                          debugger;
                          location.reload();
                        })
                    }
                  );
                }
                
                if(variant_quantity.length > 0)
                {
                  let _finalpayloadData = [];
                  let _payloadData = {};
                  $.each(shopifycartietmlist, function(key, shopfy_item) 
                  {
                   
                    if(variant_quantity.filter(o => o.id == shopfy_item.id).length > 0)
                     {
                       let _payloadData = {};
                       _payloadData.id = shopfy_item.key;
                        _payloadData.quantity = variant_quantity.filter(o => o.id == shopfy_item.id)[0].quantity;
                       _finalpayloadData.push(_payloadData);
                      }
                  });

                  if(variant_quantity.length == 1)
                  {
                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                        'Content-Type': 'application/json'
                        },body: JSON.stringify(_finalpayloadData[0])
                        })
                        .then(response => {
                          debugger;
                          location.reload();
                        })
                  }
                if(variant_quantity.length == 2)
                  {
                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                        'Content-Type': 'application/json'
                        },body: JSON.stringify(_finalpayloadData[0])
                        })
                        .then(response => {
                          debugger;
                                    fetch('/cart/change.js', {
                                  method: 'POST',
                                  headers: {
                                  'Content-Type': 'application/json'
                                  },body: JSON.stringify(_finalpayloadData[1])
                                  })
                                  .then(response => {
                                    debugger;
                                    location.reload();
                                  })
                        })
                   } 
           }
              }
                if( $('#continue_button').text() == "Pay now  ")
                {
                     // alert('Pay now ');
                  /*   let _payloadDataadd = {};
                    _payloadDataadd.emailid = customerEmail;
                    _payloadDataadd.IsForCartDetailAfterSucessOrder = true;
                    $.ajax({
                        headers: _apiheaders,
                        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetailDelete',
                        type: 'POST',
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        data: JSON.stringify(_payloadDataadd),
                        success: function(result) 
                      {
                        console.log(result);
                      }
                    }); */
                  }
              if( $('#continue_button').text() == "Pay now  " || $('#continue_button').text() == "Continue to payment  ")
                {
                  let _gstin = $('#checkout_gstno').html();
                  if(_gstin != undefined && _gstin != '')
                  {
                   checkGSTIN(_gstin);
                  }
                }
            }
       }
    });
 
        }
            }
             );
}
  

function dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}

function restricteduserforcheckout(customerEmail) {
  debugger;
  $.ajax({
        headers: _apiheaders,
        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetail/'+customerEmail,
        type: 'GET',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function(result) 
        {
          if(result != null && result.content != null)
          {
            if(result.content.length > 0)
            {
              let payloadDataadd = {};
              let _items =[];
                  $.each(result.content, function(key, _item) {
                    let obj ={};
                    obj.id = _item.variantid;
                    obj.quantity = _item.qty;
                    obj.carttoken = _item.carttoken;
                    _items.push(obj);
                  });
                payloadDataadd.items = _items;
                
                $.each(payloadDataadd.items, function(key, shopfy_item) 
                {
                    $.ajax({
                    url: 'https://rdonlineserviceqa.myshopify.com/cart/change.js?id='+shopfy_item.id+'%3A'+shopfy_item.carttoken+'&quantity=0',
                    type: 'GET',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function(result) 
                    {
                      debugger;
                    }});
                });
            }
          }
        }
    });
}

async function checkGSTIN(customerGSTIN) 
{
  debugger;
           let payloadData = {};
           var MSO1300E3_L1 = document.querySelectorAll('[data-product-id]')[0].getAttribute('data-product-id');
           var MSO1300E3_L0 = document.querySelectorAll('[data-product-id]')[0].getAttribute('data-product-id');
           var MSO1300E3_L0_Qty = $('.product-thumbnail__quantity').text();
           payloadData.GSTNumber = customerGSTIN;
            debugger;
                if (MSO1300E3_L1 == '7117463584838') 
                {
                var MSO1300E3_L1_Qty = 0;
                var slides = document.getElementsByClassName("product-thumbnail__quantity");
                  for (var i = 0; i < slides.length; i++) 
                  {
                    MSO1300E3_L1_Qty = MSO1300E3_L1_Qty + Number(slides.item(i).innerHTML);
                  }
                  payloadData.MSO1300E3_L1 = MSO1300E3_L1;
                  payloadData.MSO1300E3_L1_Qty = MSO1300E3_L1_Qty;
                }
  
                if (MSO1300E3_L0 == '6883505799238') 
                {
                  var MSO1300E3_L0_Qty = 0;
                  var slides = document.getElementsByClassName("product-thumbnail__quantity");
                    for (var i = 0; i < slides.length; i++) 
                    {
                        MSO1300E3_L0_Qty = MSO1300E3_L0_Qty + Number(slides.item(i).innerHTML);
                    }
                  payloadData.MSO1300E3_L0 = MSO1300E3_L0;           
                  payloadData.MSO1300E3_L0_Qty = MSO1300E3_L0_Qty;
                }
           
          $.ajax({
            headers: _apiheaders,            
            url:'https://rdservice.rdbusinessapplication.com/OTBSValidatorMS/apiconnector/GSTValidate',
            type: 'POST',
            contentType:"application/json; charset=utf-8",
            dataType:"json",
            data:JSON.stringify(payloadData),
            success: function (result) {
              console.log(result);
              //return result;
              if(result.success == true){
                // alert(result);
                
                var response = result.content[0];
                debugger;
                if(response.GSTresponse == null)
                  {
                    if(response.GSTIN_ValidationError != null && response.GSTIN_ValidationError != '' )
                    {
                      alert('Please Note- Maximum 50 quantity (L1/L0 devices) can be purchased against one GSTN in one month and more devices can be purchased for Non-GSTN orders.');
                      var _newUrl = window.location.href.split('?');
                    var newUrl = _newUrl[0]+'?step=contact_information';
                      window.location.replace(newUrl);
                    }
                  }
                  else
                    {
                      if( $('#continue_button').text() == "Pay now  ")
                      {
                        document.getElementById('continue_button').disabled = false;    
                      }
                    }
              }
              
            }});
 
}

async function CardDetailPaymentDelete(emailid) {
    debugger;
    let payloadDataadd = {};
    payloadDataadd.emailid = emailid;
  
    $.ajax({
        headers: _apiheaders,
        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetailPaymentDelete',
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(payloadDataadd),
        success: function(result) {
                            let _payloadSessionDelete = {};
                  _payloadSessionDelete.emailid = params.emailid;
                       $.ajax({
                        headers: _apiheaders,
                        url: GlobalValidateServiceApiUrl + '/apiconnector/CartDetailSessionDelete',
                        type: 'POST',
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        data: JSON.stringify(_payloadSessionDelete),
                        success: function(result) {
                            console.log(result);
                        }
                    });
            console.log(result);
        }
    });
}

//
/* 
 
 fetch('/cart/add.js', {
     method: 'POST',
     headers: {
     'Content-Type': 'application/json'
     },
   url: 'https://rdservice.rdbusinessapplication.com/OTBSValidatorMS/ApiConnector/CartDetail',
     body: JSON.stringify(payloadDataadd)
     })
 .then(response => {

     })

 let payloadDataupdate = {};
 fetch('/cart/update.js', {
     method: 'POST',
     headers: {
     'Content-Type': 'application/json'
     },
   url: 'https://rdservice.rdbusinessapplication.com/OTBSValidatorMS/ApiConnector/CartDetail',
     body: JSON.stringify(payloadDataupdate)
     })
 .then(response => {

   
     })

     let payloadDataremove = {};
 fetch('/cart/remove.js', {
     method: 'POST',
     headers: {
     'Content-Type': 'application/json'
     },
   url: 'https://rdservice.rdbusinessapplication.com/OTBSValidatorMS/ApiConnector/CartDetail',
     body: JSON.stringify(payloadDataremove)
     })
 .then(response => {

     })

   
     .catch((error) => {
     console.error('Error:', error);
     });
 */




// function removeItem() {

// }

// function addIDtoCart() {
//     $('button[data-cart-submit]').attr('id', 'cartBtnsubmit');
//     //alert('ID_added');
// }

// function findCartitemId() {
//     var dataCartItemId = $('[data-cart-item]').attr('data-cart-item-id');
//     var id = dataCartItemId.split(':')[0];
//     // console.log(id);
//     // alert(id);
// }

//function to call

//addIDtoCart();
//findCartitemId();

//customerId_email


// });


//{"version":"v5.31","locked":false,"scope":"product","access_granted":true,"access_denied":false,"manual_lock":false,"server_lock":false,"server_rendered":false,"hide_resource":false,"hide_links_to_resource":false,"transparent":true,"locks":{"all":[],"opened":[]},"keys":[],"keys_signature":"b613679a0814d9ec772f95d778c35fc5ff1697c493715653c6c712144292c5ad","state":{"template":"product.rdservicedemo","theme":122372915270,"product":"rd-service-demo","collection":null,"page":null,"blog":null,"article":null,"app":null},"shop":{"customer_accounts_enabled":true},"now":1706619628,"path":"/products/rd-service-demo","canonical_url":"https:\/\/rdonlineserviceqa.myshopify.com\/products\/rd-service-demo","customer":{"id":"5921118552134","email":"vivek.sharma5@idemia.com"}}
